var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2202_16862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 27.5C55 42.686 42.686 55 27.5 55C12.314 55 0 42.686 0 27.5C0 12.314 12.3076 0 27.5 0C42.6924 0 55 12.314 55 27.5Z",
    fill: "url(#paint0_linear_2202_16862)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1448 28.2562C19.1448 30.4674 17.8803 32.2655 16.3173 32.2655C14.7542 32.2655 13.4961 30.4737 13.4961 28.2562C13.4961 26.0386 14.7605 24.2468 16.3173 24.2468C17.874 24.2468 19.1448 26.045 19.1448 28.2562Z",
    fill: "#562912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0442 28.2562C42.0442 30.4674 40.7798 32.2655 39.223 32.2655C37.6663 32.2655 36.3955 30.4737 36.3955 28.2562C36.3955 26.0386 37.6599 24.2468 39.223 24.2468C40.7861 24.2468 42.0442 26.045 42.0442 28.2562Z",
    fill: "#562912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9954 43.4485C36.7134 43.5947 37.2027 42.5335 36.7261 41.8346C34.642 38.7656 31.4079 36.7896 27.767 36.7896C24.1262 36.7896 20.892 38.7656 18.8143 41.8346C18.3377 42.5335 18.8334 43.5947 19.545 43.4485C22.0167 42.9465 24.8124 42.6606 27.767 42.6606C30.7216 42.6606 33.5237 42.9465 35.9891 43.4485H35.9954Z",
    fill: "#562912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3315 21.0952C44.2871 21.0952 44.2426 21.0952 44.1918 21.0825C39.7249 20.3899 37.4756 16.7682 37.3866 16.6157C37.1325 16.19 37.2659 15.6435 37.6853 15.383C38.111 15.1225 38.6574 15.2623 38.918 15.6816C38.9497 15.7325 40.8559 18.7506 44.465 19.3098C44.9542 19.386 45.291 19.8435 45.2147 20.3327C45.1448 20.7775 44.7636 21.0952 44.3315 21.0952Z",
    fill: "#562912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2084 21.0952C10.7764 21.0952 10.3951 20.7775 10.3252 20.3327C10.249 19.8435 10.5857 19.386 11.075 19.3097C14.7285 18.7442 16.603 15.7134 16.622 15.6816C16.8762 15.2559 17.429 15.1225 17.8547 15.3766C18.2804 15.6308 18.4138 16.1836 18.1533 16.6093C18.058 16.7618 15.8151 20.3899 11.3482 21.0761C11.3037 21.0825 11.2529 21.0888 11.2084 21.0888V21.0952Z",
    fill: "#562912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3173 41.0212C16.3173 43.1752 14.57 44.9162 12.4223 44.9162C10.2747 44.9162 8.52734 43.1689 8.52734 41.0212C8.52734 39.3756 10.8021 35.4679 11.8759 33.7205C12.1237 33.3139 12.7146 33.3139 12.9688 33.7205C14.0426 35.4679 16.3173 39.3692 16.3173 41.0212Z",
    fill: "#61C0EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2202_16862",
    x1: 27.5,
    y1: -5.88378,
    x2: 27.5,
    y2: 50.1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#75BEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F6CD0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2202_16862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadOn);
export default __webpack_public_path__ + "static/media/bad_on.516bacf3a02247511dfb0a9f33135db1.svg";
export { ForwardRef as ReactComponent };